import React, {useEffect, useMemo, useState} from "react";
import moment from "moment";
import {Calendar, DateRange, momentLocalizer, ToolbarProps} from "react-big-calendar";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import '../../pages/groups/group-container/students/students-pages/students-timetable/style.css';
import {useAppDispatch, useAppSelector} from "common/hook";
import 'moment/locale/ru';
import {
    CustomModal
} from "components/pages/groups/group-container/students/students-pages/students-timetable/custom-modal/CustomModal";
import {useParams} from "react-router-dom";
import {formatDate} from "common/utils/calendar/dateUtils";
import EventComponent
    from "components/pages/groups/group-container/students/students-pages/students-timetable/event-component/EventComponent";
import {handleShowMore} from "common/utils/calendar/handleShowMore";
import {EventType} from "features/model/types/EventType";
import {handleSelectSlot} from "common/utils/calendar/handleSelectSlot";
import {CustomToolbarDev} from "components/pages/calendar-dev/CustomToolbarDev";
import {fetchCabinetData} from "entities/Cabiner/model/featchCabinetData/featchCabinetData";
import {fetchScheduleDev} from "features/model/service/groups/schedule-dev/fetchScheduleDev";
import {fetchScheduleUsers} from "features/model/service/groups/schedule-dev/fetchScheduleUsers";


moment.locale("ru");
const localizer = momentLocalizer(moment);

export const CalendarDev = () => {
    const { userId } = useParams<{ userId: string }>();
    const dispatch = useAppDispatch();
    const pendingFilters = useAppSelector((state) => state.filers);
    const scheduleDevData = useAppSelector(state => state.scheduleDev)
    const [eventsData, setEventsData] = useState<any[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedEvents, setSelectedEvents] = useState<any[]>([]);
    const [selectedTimeZone, setSelectedTimeZone] = useState<string | null>(null);
    const [currentMonthYear, setCurrentMonthYear] = useState(new Date());
    const [starting, setStarting] = useState(new Date());
    const [sendFilter, setSendFilter] = useState<boolean>(false)


    useEffect(() => {
        dispatch(fetchScheduleUsers())
    }, []);


    useEffect(() => {
        dispatch(fetchCabinetData())
    }, []);

    const handleShowMoreEvents = (events: EventType[], date: Date) => {
        handleShowMore(events, eventsData, setSelectedEvents, setIsModalOpen);
        setStarting(date)
    };


    const customHandleSelectSlot = ({start, end}: DateRange) => {
        handleSelectSlot(start, end, eventsData, setSelectedEvents, setIsModalOpen, setStarting);
    };


    useEffect(() => {
        if (scheduleDevData.data && typeof scheduleDevData.data === 'object') {
            const newEventsData = Object.values(scheduleDevData.data).flatMap((eventGroup) => (
                eventGroup.map((event) => ({
                    id: event.id,
                    title: event.title,
                    start: new Date(event.startAt),
                    end: new Date(event.finishAt),
                    status: event.status,
                    problems: event.problems,
                    hasProblem: event.hasProblems,
                    groupId: event.group?.id,
                    groupTitle: event.group?.title,
                }))
            ));

            setEventsData(newEventsData);
        }
    }, [scheduleDevData]);


    const getMonthNumber = (date: Date) => {
        return date.getMonth() + 1;
    };

    const fetchScheduleData = (newDate: Date) => {
        setCurrentMonthYear(newDate)
        const month = getMonthNumber(newDate).toString();
        const year = newDate.getFullYear().toString();
        dispatch(
            fetchScheduleDev({
                scheduleData: {
                    month: month,
                    year: year,
                    time_zone: selectedTimeZone,
                    new: pendingFilters?.isNew ? 1 : 0,
                    finished: pendingFilters?.finished ? 1 : 0,
                    has_problem: pendingFilters?.has_problem ? 1 : 0,
                },
                userId: userId,
            })
        );
    };


    useEffect(() => {
        const month = getMonthNumber(currentMonthYear).toString();
        const year = currentMonthYear.getFullYear().toString();
        dispatch(
            fetchScheduleDev({
                scheduleData: {
                    month: month,
                    year: year,
                    time_zone: selectedTimeZone,
                    new: pendingFilters?.isNew ? 1 : 0,
                    finished: pendingFilters?.finished ? 1 : 0,
                    has_problem: pendingFilters?.has_problem ? 1 : 0,
                },
                userId: userId,
            })
        );
    }, [dispatch, sendFilter, selectedTimeZone, userId]);


    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const {components} = useMemo(() => ({
        components: {
            toolbar: (props: ToolbarProps<Event, object>) => (
                <CustomToolbarDev
                    onNavigate={props.onNavigate}
                    label={props.label}
                    date={props.date}
                    view={props.view}
                    views={props.views}
                    localizer={props.localizer}
                    onView={props.onView}
                    setSendFilter={setSendFilter}
                />
            ),
            event: (props: any) => (
                <EventComponent
                    status={props.event.status}
                    hasProblem={props.event.hasProblem}
                    start={props.event.start}
                />
            ),
        }
    }), []);

    const formattedDate = formatDate(new Date(starting));

    return (
        <div className='calendar-dev'>
            <div className='calendarContainer' style={{width: '100%'}}>
                <Calendar
                    views={["month"]}
                    selectable
                    localizer={localizer}
                    defaultDate={new Date()}
                    defaultView="month"
                    events={eventsData}
                    onSelectEvent={customHandleSelectSlot}
                    onSelectSlot={customHandleSelectSlot}
                    onShowMore={handleShowMoreEvents}
                    onNavigate={(newDate, view, action) => fetchScheduleData(newDate)}
                    components={components as any}
                />
                {/*model*/}
                <CustomModal
                    selectedEvents={selectedEvents}
                    formattedDate={formattedDate}
                    isModalOpen={isModalOpen}
                    handleOk={handleOk}
                    handleCancel={handleCancel}
                />

            </div>
        </div>
    );
};

